import script from "./TextBox.vue?vue&type=script&setup=true&lang=js"
export * from "./TextBox.vue?vue&type=script&setup=true&lang=js"

import "./TextBox.vue?vue&type=style&index=0&id=ecde420c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecde420c"]])

export default __exports__